import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import BOXImage from "../../../assets/images/box_1.png";

const defaultBox = {
  dimensions: { length: "", width: "", height: "", weight: "" },
  items: [{ description: "", category: "", qty: "", price: "" }],
};

const PackageManager = () => {
  const [boxes, setBoxes] = useState([{ ...defaultBox }]);

  const handleDimensionChange = (index, key, value) => {
    const updatedBoxes = [...boxes];
    updatedBoxes[index].dimensions[key] = value;
    setBoxes(updatedBoxes);
  };

  const handleItemChange = (boxIndex, itemIndex, key, value) => {
    const updatedBoxes = [...boxes];
    updatedBoxes[boxIndex].items[itemIndex][key] = value;
    setBoxes(updatedBoxes);
  };

  const addItem = (boxIndex) => {
    const updatedBoxes = [...boxes];
    const box = { ...updatedBoxes[boxIndex] };
    const newItem = { description: "", category: "", qty: "", price: "" };

    // clone items array to avoid mutation issues
    box.items = [...box.items, newItem];

    updatedBoxes[boxIndex] = box;
    setBoxes(updatedBoxes);
  };

  const removeItem = (boxIndex, itemIndex) => {
    const updatedBoxes = [...boxes];
    const box = { ...updatedBoxes[boxIndex] };

    box.items = box.items.filter((_, i) => i !== itemIndex);
    updatedBoxes[boxIndex] = box;
    setBoxes(updatedBoxes);
  };

  const addBox = () => {
    setBoxes([...boxes, { ...defaultBox }]);
  };

  const removeBox = (index) => {
    const updatedBoxes = [...boxes];
    updatedBoxes.splice(index, 1);
    setBoxes(updatedBoxes);
  };

  return (
    <Box>
      {boxes.map((box, boxIndex) => (
        <Box
          key={boxIndex}
          sx={{
            border: "2px solid",
            borderColor: "#E5E5E8",
            borderRadius: "10px",
            p: 2,
            mb: 3,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight={700} color="primary">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <img
                  src={BOXImage}
                  alt={"box_image"}
                  style={{
                    width: "20px",
                    height: "20px",
                    objectFit: "contain",
                    marginRight: "10px",
                    marginBottom: 1,
                  }}
                />
                <span>BOX {boxIndex + 1}</span>
              </div>
            </Typography>
            {boxes.length !== 1 && (
              <IconButton
                onClick={() => removeBox(boxIndex)}
                disabled={boxes.length === 1}
              >
                <DoNotDisturbOnIcon
                  style={{
                    color: "#EB5757",
                  }}
                />
              </IconButton>
            )}{" "}
          </Box>

          {/* Box Dimensions */}
          <Box mt={2}>
            <Typography fontWeight={700} mb={1}>
              Box Dimensions
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2}>
              {["length", "width", "height", "weight"].map((key) => (
                <Box key={key} sx={{ minWidth: 170, flex: 1 }}>
                  <Typography fontSize={14} fontWeight={500}>
                    {key.charAt(0).toUpperCase() + key.slice(1)}{" "}
                    {key === "weight" ? "(lb)" : "(in)"}
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="Enter"
                    value={box.dimensions[key]}
                    onChange={(e) =>
                      handleDimensionChange(boxIndex, key, e.target.value)
                    }
                  />
                </Box>
              ))}
            </Box>
          </Box>

          {/* Items Table */}
          <Box mt={3}>
            <Typography fontWeight={700} mb={1}>
              Item in Box
            </Typography>
            <Table
              size="small"
              sx={{ border: "1px solid #E0E0E0", borderRadius: 2 }}
            >
              <TableHead>
                <TableRow>
                  {[
                    "Description",
                    "Category",
                    "QTY",
                    "Unit Price",
                    "Value",
                    "Action",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      style={{ color: "#c0c0c5", fontWeight: 600 }}
                      sx={{ border: "1px solid #E0E0E0" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {box.items.map((item, itemIndex) => (
                  <TableRow key={itemIndex}>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      <TextField
                        placeholder="Enter"
                        size="small"
                        value={item.description}
                        onChange={(e) =>
                          handleItemChange(
                            boxIndex,
                            itemIndex,
                            "description",
                            e.target.value
                          )
                        }
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      <TextField
                        placeholder="Enter"
                        size="small"
                        value={item.category}
                        onChange={(e) =>
                          handleItemChange(
                            boxIndex,
                            itemIndex,
                            "category",
                            e.target.value
                          )
                        }
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      <TextField
                        placeholder="Enter"
                        size="small"
                        type="number"
                        value={item.qty}
                        onChange={(e) =>
                          handleItemChange(
                            boxIndex,
                            itemIndex,
                            "qty",
                            e.target.value
                          )
                        }
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      <TextField
                        placeholder="Enter"
                        size="small"
                        type="number"
                        value={item.price}
                        onChange={(e) =>
                          handleItemChange(
                            boxIndex,
                            itemIndex,
                            "price",
                            e.target.value
                          )
                        }
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      {item.qty && item.price
                        ? (
                            parseFloat(item.qty) * parseFloat(item.price)
                          ).toFixed(2)
                        : ""}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #E0E0E0" }}>
                      {box.items.length !== 1 && (
                        <IconButton
                          onClick={() => removeItem(boxIndex, itemIndex)}
                          disabled={box.items.length === 1}
                        >
                          <DoNotDisturbOnIcon style={{ color: "#EB5757" }} />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Button
              onClick={() => addItem(boxIndex)}
              size="small"
              style={{
                mt: 1,
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "120%",
                letterSpacing: "0px",
              }}
            >
              Add item
            </Button>
          </Box>
        </Box>
      ))}
      <Button
        style={{
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "120%",
          letterSpacing: "0px",
        }}
        onClick={addBox}
      >
        Add Another box
      </Button>
    </Box>
  );
};

export default PackageManager;
